import styled from "@emotion/styled";
import { Body, fonts } from "@trustpilot/businessapp-patternlibrary";

const StyleHeaderCopy = styled.div({
  zIndex: 5,
  position: "relative",
});

const StyleHeaderCrossHide = styled.div({
  position: "absolute",
  zIndex: 4,
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "var(--neutral-white)",
});

const StyledBannerAlert = styled.div({
  margin: "0 0 16px",
});

const StyledParagraph = styled.div({
  margin: "0 0 16px",
});

interface StyledCheckboxBannerProps {
  error: React.ReactElement;
}

const StyledCheckboxBanner = styled.section<StyledCheckboxBannerProps>(
  {
    backgroundColor: "var(--alert-background)",
    borderRadius: 4,
    overflow: "hidden",
  },
  ({ error }) => ({
    border: `1px solid ${error ? "var(--border-critical)" : "var( --divider-subtle)"}`,
  }),
);

const StyledCheckboxBannerWrapper = styled.div({
  padding: 16,
  display: "flex",
  alignItems: "flex-start",
});

const StyledCheckboxLabel = styled(Body)({
  margin: 0,
});

const StyledError = styled.div({
  ...fonts["body-2"],
  padding: 8,
  backgroundColor: "var(--action-critical-background)",
  color: "var(--actions-primary-text)",
});

export {
  StyleHeaderCopy,
  StyleHeaderCrossHide,
  StyledBannerAlert,
  StyledParagraph,
  StyledCheckboxBanner,
  StyledCheckboxBannerWrapper,
  StyledCheckboxLabel,
  StyledError,
};
